// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KQpOe","content":"styles_content__1nduG","row":"styles_row__3Ms1M","footer":"styles_footer__1-jhr","phraseLength":"styles_phraseLength__3Gh0v"};